export const getProjectRestoreUrl = (baseUrl: string, projectId: number | string): string =>
	`${baseUrl}/rest/api/2/project/${projectId}/restore`;
